import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
  GECKO_UTILS,
} from 'ui';
import { connect } from 'react-redux';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';

class ConnectLoginModal extends Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      values: this.props.values,
      loading: false,
    };
  }

  fields = [
    {
      key: 'ClientName',
      label: 'Webservice Client Name',
      description:
        'Can be found when logged in to Connect by hovering over the username in the top right and clicking on "UPDATE PROFILE".',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_NAME,
    },
    {
      key: 'PassKey',
      label: 'PassKey',
      description:
        'When logged in to Connect, hover over the username in the top right and click on "UPDATE PROFILE". Create a new webservice user, which will generate a token to be entered below.',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    },
    {
      key: 'connectUrl',
      label: 'Webservice Region',
      required: true,
      width: '100%',
      options: [
        {
          label: 'EMEA',
          value: 'https://services01.askadmissions.co.uk/ws/bridge.asmx?wsdl',
        },
        {
          label: 'US - West',
          value: 'https://services01.askadmissions.net/ws/bridge.asmx?wsdl',
        },
        {
          label: 'US - East',
          value: 'https://services02.askadmissions.net/ws/bridge.asmx?wsdl',
        },
      ],
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
    },
  ];

  footerButtons = [
    {
      name: 'Done',
      type: 'primary',
      icon: 'far fa-check',
      handler: () => {
        this.handleSubmit.bind(this)();
      },
    },
  ];

  onUserInput(key, value) {
    const newValue = GECKO_UTILS.setNestedValue(this.state.values, key, value);
    this.setState({ values: newValue });
  }

  handleSubmit() {
    const validateRequired = (fields, values) => {
      return fields.reduce((valid, field) => {
        if (field.required && !GECKO_UTILS.getNestedValue(values, field.key)) {
          new GeckoToastService().error(`The ${field.label} field is required`);
          return false;
        }
        return valid;
      }, true);
    };
    const valid = validateRequired(this.fields, this.state.values);
    if (!valid) {
      return;
    }

    const newConnectIntegration = {
      type: 'connect',
      configuration: {
        ClientName: this.state.values.ClientName,
        PassKey: this.state.values.PassKey,
        url: this.state.values.connectUrl,
      },
      account_id: this.props.current_user.account_id,
    };
    this.setState({ loading: true });
    return GeckoRequest.post('/integration/', newConnectIntegration)
      .then((integration) => {
        if (integration.id) {
          GeckoLocation.goTo(`/settings/integration/connect`);
          new GeckoToastService().success('Connect integration created');
          return new GeckoModalService().close();
        } else {
          new GeckoToastService().error(integration.error);
        }
      })
      .catch(renderError)
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    return (
      <Loader isLoading={this.state.loading}>
        <GeckoModal
          name="Please enter your Connect Web Service credentials:"
          fields={this.fields}
          values={this.state.values}
          btns={this.footerButtons}
          handler={this.onUserInput.bind(this)}
        />
      </Loader>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultHeaders: state.appState.defaultHeaders,
    current_user: state.appState.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectLoginModal);
